<i class="fa fa-filter"></i>{{'filterButton' | translate}}